export const REGEXPS = {
    PASSWORD: `^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$`,
    PHONE: `^[0-9]{10}$`,
    ZIPCODE: `^[0-9]{5}$`,
    NUMBER_ONLY:`^[0-9]+(\.?[0-9]+)?$`,
    NAME: `^[a-zA-Z0-9 _()$\-']*$`,
    CARDZIPCODE: `^((\\d{5}-\\d{4})|(\\d{5})|([AaBbCcEeGgHhJjKkLlMmNnPpRrSsTtVvXxYy]\\d[A-Za-z] ?\\d[A-Za-z]\\d))$`,
}